import {defineAsyncComponent, reactive} from 'vue'
import defaults from "@/config/default.json"

import AbstractRouterManager from '@/routers/abstractroutermanager'
import AbstractStoreManager from '@/models/abstractstoremanager';
import AbstractAdminManager from "@/admins/abstractadminmanager";
import appConfig from "@/config/config.json"
import UserStoreManager from "@/models/userstore/userstoremanager";

export const container = reactive({})
export const Assets = require.context('@/assets/', true, /.*/i);

// plugin
export default {
    install: (app, options) => {
        container.routerManager = new AbstractRouterManager()
        container.storeManager = new AbstractStoreManager()
        container.adminManager = new AbstractAdminManager()
        container.userStoreManager = new UserStoreManager()

        container.routerManager.loadRoutes()
        container.adminManager.loadAdmins()


        app.provide('container', options)
    }
}

function loadConfig() {
    container.config = deepMerge(defaults, appConfig)
}

export function useConfig() {
    if (!container || !container.config)
        loadConfig()

    return container.config
}

let menus = {}

function loadMenu(menu) {
    for (let i in menu) {
        if (menu[i].submenu) {
            loadMenu(menu[i].submenu)
        } else if (menu[i].admin) {
            if (menu[i].to)
                menu[i].to = useAdmin(menu[i].admin.name).getRoute(menu[i].to)
            else
                menu[i].to = useAdmin(menu[i].admin.name).getRoute('list')
        } else if (menu[i].to) {
            useRouterManager().getRoute(menu[i].to)
            menu[i].to = {name: menu[i].to}
        }
    }
}

export function useMenu(name) {
    if (!name) name = 'default'
    if (!menus[name]) {
        useConfig()
        if (container.config.menu instanceof Array && name != 'default') {
            console.error(`Undefined Menu with name '${name}'`,)
            return {}
        }
        const menu = container.config.menu instanceof Array ? container.config.menu : container.config.menu[name]
        loadMenu(menu)
        menus[name] = menu
    }

    return menus[name]
}

export function useRouterManager() {
    return container.routerManager
}

export function useRouter() {
    return container.routerManager.getRouter()
}

// export function useStoreManager() {
//     return container.storeManager
// }
export function useStore(storeName) {
    return container.storeManager.useStore(storeName)()
}

export function useAdmin(adminCode) {
    const admin = container.adminManager.useAdmin(adminCode)

    return admin
}

export function useUserStore() {
    return container.userStoreManager.useUserStore()()
}

export function useLayout(layout) {
    return import(`@/components/${layout}`)
}

export function deepMerge(defaultProps, props, byRef = true) {
    let _defs
    if (byRef)
        _defs = defaultProps
    else
        _defs = JSON.parse(JSON.stringify(defaultProps))

    deepMergeRecursive(_defs, props)
    return _defs
}

function deepMergeRecursive(defaultProps, props) {
    for (let k in props) {
        if (props[k] === null || props[k] === undefined)
            continue;
        if (defaultProps[k] && props[k] instanceof Object) {
            if (props[k] instanceof Array) {
                let templateProps = JSON.stringify(defaultProps[k])
                defaultProps[k] = []
                for (let subK in props[k]) {
                    defaultProps[k][subK] = JSON.parse(templateProps)
                    deepMergeRecursive(defaultProps[k][subK], props[k][subK])
                }
            } else {
                deepMergeRecursive(defaultProps[k], props[k])
            }
        } else {
            defaultProps[k] = props[k]
        }
    }
}

export function humanize(str) {
    return str
        .replace(/^[\s_.]+|[\s_.]+$/g, '')
        .replace(/[._\s]+/g, ' ')
        .replace(/^[a-z]/g, function (m) {
            return m.toUpperCase();
        })
        .replaceAll(/\s[a-z]/g, function (m) {
            return m.toUpperCase();
        });
}

const VComps = {}

export function useVComp(comp) {
    console.log("in")
    if (!VComps[comp]) {
        return defineAsyncComponent(() => import('vuetify/lib/components').then(module => {
            VComps[comp] = module[comp];
            return module[comp]
        }))
    } else {
        return VComps[comp]
    }
}

Array.prototype.popItem = function (item) {
    const index = this.indexOf(item);
    if (index > -1) {
        this.splice(index, 1);
    }
    return this
};

export function clear(object) {
    Object.keys(object).forEach(key => delete object[key]);
    return this
}

const MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];


function getFormattedDate(date, prefomattedDate = false, hideYear = false) {
    const day = date.getDate();
    const month = MONTH_NAMES[date.getMonth()];
    const year = date.getFullYear();
    const hours = date.getHours();
    let minutes = date.getMinutes();

    if (minutes < 10) {
        // Adding leading zero to minutes
        minutes = `0${minutes}`;
    }

    if (prefomattedDate) {
        // Today at 10:20
        // Yesterday at 10:20
        return `${prefomattedDate} at ${hours}:${minutes}`;
    }

    if (hideYear) {
        // 10. January at 10:20
        return `${day}. ${month} at ${hours}:${minutes}`;
    }

    // 10. January 2017. at 10:20
    return `${day}. ${month} ${year}. at ${hours}:${minutes}`;
}


export function timeAgo(dateParam) {
    if (!dateParam) {
        return null;
    }

    const date = typeof dateParam === 'object' ? dateParam : new Date(dateParam);
    const DAY_IN_MS = 86400000; // 24 * 60 * 60 * 1000
    const today = new Date();
    const yesterday = new Date(today - DAY_IN_MS);
    const seconds = Math.round((today - date) / 1000);
    const minutes = Math.round(seconds / 60);
    const isToday = today.toDateString() === date.toDateString();
    const isYesterday = yesterday.toDateString() === date.toDateString();
    const isThisYear = today.getFullYear() === date.getFullYear();


    if (seconds < 5) {
        return 'now';
    } else if (seconds < 60) {
        return `${seconds} seconds ago`;
    } else if (seconds < 90) {
        return 'about a minute ago';
    } else if (minutes < 60) {
        return `${minutes} minutes ago`;
    } else if (isToday) {
        return getFormattedDate(date, 'Today'); // Today at 10:20
    } else if (isYesterday) {
        return getFormattedDate(date, 'Yesterday'); // Yesterday at 10:20
    } else if (isThisYear) {
        return getFormattedDate(date, false, true); // 10. January at 10:20
    }

    return getFormattedDate(date); // 10. January 2017. at 10:20
}

export function getCookieByName(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}